import { creditAxiosApi } from "services/axiosApi/axiosApi";

export const getRejectionReason = async (token: string) => {
    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return await creditAxiosApi.get(`/RejectionReason`, config);
}